import React, { useEffect, useState } from 'react';

import { ButtonTypes, StandardButton } from '@eika/button';

import { timeBeforeInactiveModalToShowInSeconds } from '../components/idle-timer-provider/idle-timer-provider-meld-skade';

import './developer-flyt-helper.scss';

interface FlytHelperProps {
    sessionUpdatedAt: Date;
    maxSessionUpdateFrequencyInSeconds: number;
}

export const DeveloperFlytHelper = ({ sessionUpdatedAt, maxSessionUpdateFrequencyInSeconds }: FlytHelperProps) => {
    const [secondsSinceSessionUpdated, setSecondsSinceSessionUpdated] = useState<number>(0);
    const [showSessionDebug, setShowSessionDebug] = useState<boolean>(false);

    useEffect(() => {
        const interval = setInterval(() => {
            const secondsSinceLastSessionUpdated = (Date.now() - sessionUpdatedAt.getTime()) / 1000;
            setSecondsSinceSessionUpdated(Math.ceil(secondsSinceLastSessionUpdated));
        }, 500);

        return () => {
            clearInterval(interval);
        };
    });

    const secondsUntilUpdateAvailable = Math.ceil(
        Math.max(0, maxSessionUpdateFrequencyInSeconds - secondsSinceSessionUpdated),
    );
    const timeTillPromptInSeconds = timeBeforeInactiveModalToShowInSeconds - secondsSinceSessionUpdated;
    const timeTillPromptInMinutes = Math.floor(timeTillPromptInSeconds / 60);

    return (
        <div className="developer-flyt-helper">
            <div
                style={{
                    width: '100%',
                }}
            >
                <StandardButton
                    buttonType={showSessionDebug ? ButtonTypes.STANDARD_POSITIVE : ButtonTypes.STANDARD_NEGATIVE}
                    onClick={() => setShowSessionDebug(!showSessionDebug)}
                >
                    Sesjonsstatus
                </StandardButton>
            </div>
            {showSessionDebug && (
                <div className="developer-flyt-helper-session-box">
                    <h3>Sesjon</h3>
                    <p>Forrige gang sesjonen ble oppdatert: {sessionUpdatedAt.toLocaleTimeString()}</p>
                    <p>Forrige oppdatering er {secondsSinceSessionUpdated} sekunder siden.</p>
                    <p>Sesjonen kan oppdateres om {secondsUntilUpdateAvailable} sekunder.</p>
                    {timeTillPromptInSeconds > 0 ? (
                        <p>
                            Tid før inaktiv-modal skal dukke opp: {timeTillPromptInMinutes} minutter og{' '}
                            {timeTillPromptInSeconds - timeTillPromptInMinutes * 60} sekunder.
                        </p>
                    ) : (
                        <p>Nedtelling vil starte igjen etter neste oppdatering blir gjort av bruker.</p>
                    )}
                </div>
            )}
        </div>
    );
};
